import ValidationType from '../ValidationType';
import { datesAreEqual, dateIsBefore } from "../../dateutil";
import moment from 'moment-timezone';

class BeforeTimeFieldEx extends ValidationType {

  get comparesField() {
    return true
  }

  validateResponseWithValidation(fieldResponse, validation, formResponse = null) {
    let errors = [];
    let current_raw;
    let compare_raw;
    let compare_print;
    if (!fieldResponse.isEmpty) {
      if (validation.target) {
        const targetFieldResponse = formResponse
          ? fieldResponse.recapResponse.getFieldResponseForFieldInstanceIdAndFormResponseId(validation.target.id, formResponse.id)
          : fieldResponse.recapResponse.getFieldResponseForFieldInstanceId(validation.target.id);
      if (!moment(targetFieldResponse.currentValue).isValid()){
        current_raw = moment(targetFieldResponse.currentValue, 'h:mma').format('h:mma');
      }
      else if( moment(targetFieldResponse.currentValue,"YYYY-MM-DDTHH:mm:ss.SSSSZ").isValid()) {
        current_raw = moment(targetFieldResponse.currentValue,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset(moment(targetFieldResponse.currentValue,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset() ).format('h:mma');;

      }
      else{

        current_raw = moment(targetFieldResponse.currentValue).utcOffset(moment(targetFieldResponse.currentValue).utcOffset() ).format('h:mma');;
      }

      if (!moment(validation.value).isValid()){

        compare_raw = moment(validation.value, 'h:mma').format('h:mma');
        compare_print = moment(validation.value, 'h:mma').format('h:mma');
      }
      else if( moment(validation.value,"YYYY-MM-DDTHH:mm:ss.SSSSZ").isValid()) {
        compare_raw = moment(validation.value,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset(moment(validation.value,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset() ).format('h:mma');
        compare_print = moment(validation.value,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset(moment(validation.value,"YYYY-MM-DDTHH:mm:ss.SSSS").utcOffset() ).format('h:mma');

      }
      else{


        compare_raw = moment(validation.value).utcOffset(moment(validation.value).utcOffset() ).format('h:mma');
        compare_print = moment(validation.value).utcOffset(moment(validation.value).utcOffset() ).format('h:mma');
      }
      const compare =  moment(compare_raw, 'h:mma').format('YYYY-MM-DD HH:mm');
      const current =  moment(current_raw, 'h:mma').format('YYYY-MM-DD HH:mm');

        if ( !dateIsBefore(current, compare)) {
          const error = this.createValidationError({
            fieldResponse,
            key: 'ERROR_BEFORE_SPECIFIED_FIELD_EX',
            values: { value: targetFieldResponse.currentValue },
            message: `Value should be before:  '${compare_print}'`,
          });
          errors.push(error);
        }
      } else {
        console.warn("No target present for validation", validation);
      }
    }
    return errors;
  }
}

export default BeforeTimeFieldEx;
